
import FeatureCard from "@/components/FeatureCard";
import { ReactNode } from "react";

interface Feature {
  icon: ReactNode;
  title: string;
  description: string;
}

const WhatWeDoSection = () => {
  const features: Feature[] = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
      ),
      title: "Colocamos sua empresa no Google",
      description: "Otimizamos sua presença digital para aparecer nos resultados de busca do Google e Google Maps."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="20" height="14" x="2" y="3" rx="2"/>
          <line x1="8" x2="16" y1="21" y2="21"/>
          <line x1="12" x2="12" y1="17" y2="21"/>
        </svg>
      ),
      title: "Melhoramos seu site",
      description: "Ajustamos seu site para ser mais atrativo para o Google e para seus potenciais clientes."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/>
          <path d="m2 12 3.5 1.5L7 17l4.5-1L12 22"/>
          <path d="M10 7.5 12.5 5l2 3L17.5 6.5 19 9"/>
        </svg>
      ),
      title: "Cadastramos você em sites confiáveis",
      description: "Inserimos suas informações em diretórios relevantes e de autoridade para fortalecer sua presença online."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 10c.7-1.74 2.27-3 4-3 1.86 0 3.4 1.43 4 3"/><path d="M10 9a1 1 0 0 0-2 0"/><path d="m19.5 12.572-.42.425a.995.995 0 0 1-1.429-.005l-2.08-2.134a.991.991 0 0 1 .028-1.399l.401-.401"/><path d="M7 20h6.5"/><path d="M13 15.055V16.5a2 2 0 0 1-2 2h-1a2 2 0 0 0-1.1.35l-2.2 1.65a2 2 0 0 1-2.4-.05L2.5 19c-.3-.2-.5-.5-.5-.9v-7.2c0-1.2 1.5-1.8 2.4-1l3.6 2.8"/><path d="M14 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/><path d="M17 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/><path d="M21 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/></svg>
      ),
      title: "Ajudamos a conseguir avaliações positivas",
      description: "Implementamos estratégias para incentivar seus clientes a deixarem avaliações, melhorando sua reputação online."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
        </svg>
      ),
      title: "Aumentamos sua visibilidade",
      description: "Expandimos o alcance da sua empresa na sua cidade e região, tornando-a mais visível para clientes em potencial."
    }
  ];

  return (
    <section id="o-que-fazemos" className="py-20 px-6 md:px-12 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4 text-seo-dark">O que fazemos por você</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Nossa equipe especializada em SEO Local implementa estratégias comprovadas para aumentar sua visibilidade online e atrair mais clientes para seu negócio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
